export default {
  button: {
    generate_pdf_file: 'een PDF-bestand genereren',
    generate_csv_file: 'een CSV-bestand genereren',
    accounting_export: 'boekhoudkundige export',
    activate: 'activeren',
    add: 'toevoegen',
    choose_timeslot: 'tijdslot kiezen',
    add_new_m: 'toevoegen een {var}',
    add_new_f: 'toevoegen een {var}',
    back: 'terug',
    cancel: 'annuleren',
    close: 'sluiten',
    create: 'aanmaken',
    edit: 'edit',
    edit_new_m: 'edit deze {var}',
    edit_new_mv: 'edit deze {var}',
    edit_new_f: 'edit deze {var}',
    attach_to_work: 'bij de bijlagen voegen',
    download: 'downloaden',
    print: 'print',
    see: 'bekijken',
    save_new_m: 'aanmelden deze {var}',
    save_new_mv: 'aanmelden deze {var}',
    save_new_f: 'aanmelden deze {var}',
    send: 'verzenden'
  }
}
